import { useState, useRef } from "react";
import { Dropdown } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { LOGOUTAtive } from "../../redux/slices/auth";
import PersonIcon from "@mui/icons-material/Person";
import LogoutIcon from "@mui/icons-material/Logout";
import HistoryOutlinedIcon from "@mui/icons-material/HistoryOutlined";
import WalletIcon from "@mui/icons-material/Wallet";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
// import introJs from "intro.js";
import AudioPlayer from "../../components/sound";
import { useClickOutside } from "../../hooks/useOutsideClick";
import { FilterTiltShift } from "@mui/icons-material";

const Topheader = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const data = useSelector((value) => value.login);
  const { isAuthenticated, user } = data;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const balance = useSelector((value) => value?.ubal?.data?.balance);
  const load = useSelector((tate) => tate.gift.loading);
  const dropdownRef = useRef(null);

  useClickOutside(dropdownRef, () => setIsMobileMenuOpen(false), [
    "burger-button",
  ]);

  const handleLogout = () => {
    console.log("Logout clicked");
    dispatch(LOGOUTAtive(navigate));
  };

  const handleDropdownToggle = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const handleLinkClick = () => {
    setDropdownOpen(false);
    setIsMobileMenuOpen(false);
  };
  // useEffect(() => {
  //   const isDesktop = window.innerWidth > 768;

  //   if (isDesktop && !localStorage.getItem("introDone")) {
  //     introJs()
  //       .setOptions({
  //         steps: [
  //           {
  //             element: "#login-btn",
  //             intro: "Click here to log in to your account.",
  //           },
  //           {
  //             element: "#signup-btn",
  //             intro: "Don't have an account? Click here to sign up.",
  //           },
  //         ],
  //         showProgress: false,
  //         showBullets: false,
  //         nextLabel: "",
  //         prevLabel: "",
  //         doneLabel: "",
  //         skipLabel: "",
  //         tooltipPosition: "bottom",
  //         scrollToElement: true,
  //         highlightClass: "custom-highlight",
  //       })
  //       .oncomplete(() => {
  //         localStorage.setItem("introDone", "true");
  //       })
  //       .start();
  //   }
  // }, [isAuthenticated]);

  return (
    <header className="sticky top-0 z-50 flex justify-between items-center px-6 bg-gradient-to-r from-[#3e0534] via-[#e4008b] to-[#3e0433] shadow-md">
      {/* <div className="flex items-center space-x-6 fleplogo">
        <Link to="/" className="inline-block relative">
          <img
            src="/images/logo.png"
            alt="Logo"
            className="rounded-full w-24 sm:w-28 md:w-32 lg:w-36 py-2"
          />
        </Link>
      </div> */}

      <div className="flex items-center flip-container w-24 sm:w-28 md:w-32 lg:w-36 py-2">
        <div className="flip-box">
          <div className="side front">
            <Link to="/" className="inline-block relative">
              <img
                src="/images/logo.png"
                alt="dannys Logo"
                className="rounded-full w-full"
              />
            </Link>
          </div>
          <div className="side back">
            <img
              src="/images/logo.png"
              alt="dannys Logo"
              className="rounded-full w-full"
            />
          </div>
        </div>
      </div>
      <div className="flex flex-row justify-center items-center gap-2 ">
        <AudioPlayer />
        {/* <a
          href="#mobile-app-section"
          className="download-app-btn ml-auto px-2 py-1 bg-gradient-to-b from-yellow-400 to-yellow-600 text-black font-bold rounded-md shadow-md border-yellow-700 hover:brightness-110 transition flex items-center"
        >
          <FileDownloadOutlinedIcon className="mr-1 download-icon-animate" />
          Mobile Apps
        </a> */}
        <a
          href="https://dannys-livechat.vercel.app/"
          rel="noreferrer"
          target="_blank"
          className="download-app-btn ml-auto px-2 py-1 bg-gradient-to-b from-yellow-400 to-yellow-600 text-black font-bold rounded-md shadow-md border-yellow-700 hover:brightness-110 transition flex items-center"
        >
          <FileDownloadOutlinedIcon className="mr-1 download-icon-animate" />
          Mobile Apps
        </a>
        {!isAuthenticated ? (
          <ul className="hidden lg:flex flex-row justify-center items-center gap-2 ">
            {/* <li>
              <Link
                to="/login"
                className="px-2 py-1 bg-gradient-to-b from-yellow-400 to-yellow-600 text-black font-bold rounded-md shadow-md  border-yellow-700 hover:brightness-110 transition"
                onClick={handleLinkClick}
                id="login-btn"
              >
                Login
              </Link>
            </li> */}
            {/* <li>
              <Link
                className="px-2 py-1 bg-gradient-to-b from-yellow-400 to-yellow-600 text-black font-bold rounded-md shadow-md  border-yellow-700 hover:brightness-110 transition"
                to="/signup"
                onClick={handleLinkClick}
                id="signup-btn"
              >
                Sign Up
              </Link>
            </li> */}
          </ul>
        ) : (
          <div className="hidden lg:flex items-center space-x-4">
            <div className="flex items-center gap-2 px-2 rounded-lg text-white">
              <WalletIcon />
              <span className="font-semibold">Balance:</span>
              <span className="font-bold">${balance ? balance : 0}</span>
            </div>
            <Dropdown
              align="end"
              show={dropdownOpen}
              onToggle={handleDropdownToggle}
            >
              {/* Profile Button */}
              <Dropdown.Toggle
                as="div"
                className="d-flex align-items-center cursor-pointer"
                onClick={handleDropdownToggle}
              >
                <img
                  src={user?.image ? user?.image : "/images/user.png"}
                  alt="Profile"
                  className="rounded-circle w-10 h-10 mr-2"
                />
                <div className="flex justify-start flex-col items-start">
                  <span className="fw-bold text-lg">{user?.name}</span>
                </div>
              </Dropdown.Toggle>

              {/* Dropdown Menu */}
              <Dropdown.Menu className="dropdownLt">
                <Link
                  to="/dashboard"
                  className="dropdown-item"
                  onClick={handleLinkClick}
                >
                  <DashboardOutlinedIcon
                    fontSize="small"
                    className="mr-1 fs-icon"
                  />
                  Dashboard
                </Link>
                <Link
                  to="/profile"
                  className="dropdown-item"
                  onClick={handleLinkClick}
                >
                  <PersonIcon fontSize="small" className="mr-1 fs-icon " />
                  Profile
                </Link>
                <Link
                  to="/history"
                  className="dropdown-item"
                  onClick={handleLinkClick}
                >
                  <HistoryOutlinedIcon
                    fontSize="small"
                    className="mr-1 fs-icon"
                  />
                  History
                </Link>
                <Link
                  to="/wallet"
                  className="dropdown-item"
                  onClick={handleLinkClick}
                >
                  <WalletIcon fontSize="small" className="mr-1 fs-icon" />
                  Wallet
                </Link>
                <Link
                  to="/cashout"
                  className="dropdown-item"
                  onClick={handleLinkClick}
                >
                  <PaymentsOutlinedIcon
                    fontSize="small"
                    className="mr-1 fs-icon"
                  />
                  Cashout
                </Link>
                <Link onClick={handleLogout} className="dropdown-item">
                  <LogoutIcon fontSize="small" className="mr-1 fs-icon" />
                  Logout
                </Link>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        )}
        <button
          id="burger-button"
          className="lg:hidden text-white focus:outline-none"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          <svg
            className="w-6 h-6"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 6h16M4 12h16m-7 6h7"
            />
          </svg>
        </button>
        <div
          className={`lg:hidden absolute top-full left-0 w-full bg-gradient-to-r from-[#3e0534] via-[#e4008b] to-[#3e0433] shadow-md transform transition-all duration-300 ease-in-out ${
            isMobileMenuOpen
              ? "opacity-100 translate-y-0"
              : "opacity-0 -translate-y-10 pointer-events-none"
          }`}
          ref={dropdownRef}
        >
          <div className="flex flex-col items-start p-4 space-y-4">
            {!isAuthenticated ? (
              <>
                <Link
                  to="/login"
                  className="block w-full text-white font-semibold py-2 border-b border-gray-400"
                  onClick={handleLinkClick}
                >
                  Login
                </Link>
                <Link
                  to="/signup"
                  className="block w-full text-white font-semibold py-2"
                  onClick={handleLinkClick}
                >
                  Sign Up
                </Link>
              </>
            ) : (
              <>
                <Dropdown
                  align="end"
                  show={dropdownOpen}
                  onToggle={handleDropdownToggle}
                >
                  <Dropdown.Toggle
                    as="div"
                    className="d-flex align-items-center cursor-pointer"
                    onClick={handleDropdownToggle}
                  >
                    <img
                      src={user?.image ? user?.image : "/images/user.png"}
                      alt="Profile"
                      className="rounded-circle w-10 h-10 mr-2"
                    />
                    <div className="flex justify-start flex-col items-start">
                      <span className="fw-bold text-lg">
                        {user?.name && user?.name}
                      </span>
                    </div>
                  </Dropdown.Toggle>
                </Dropdown>

                <div className="flex items-center gap-2 py-2 text-white">
                  <img
                    src="/images/header/balance.png"
                    alt="Balance Icon"
                    className="w-5 h-5"
                  />
                  <span className="font-semibold">Balance:</span>
                  <span
                    className={`font-bold ${
                      load ? "text-orange-600 animate-pulse" : ""
                    }`}
                  >
                    ${balance ? balance : 0}
                  </span>
                </div>
                {/* Profile Dropdown Links */}
                <ul className="w-full text-white font-semibold space-y-2">
                  <li className="border-b border-gray-400 pb-2">
                    <Link
                      to="/profile"
                      className="hover:underline"
                      onClick={handleLinkClick}
                    >
                      Profile
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/dashboard"
                      className="dropdown-item"
                      onClick={handleLinkClick}
                    >
                      <DashboardOutlinedIcon
                        fontSize="small"
                        className="mr-1 fs-icon"
                      />
                      Dashboard
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/history"
                      className="dropdown-item"
                      onClick={handleLinkClick}
                    >
                      <HistoryOutlinedIcon
                        fontSize="small"
                        className="mr-1 fs-icon"
                      />
                      History
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/wallet"
                      className="dropdown-item"
                      onClick={handleLinkClick}
                    >
                      <WalletIcon fontSize="small" className="mr-1 fs-icon" />
                      Wallet
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/cashout"
                      className="dropdown-item"
                      onClick={handleLinkClick}
                    >
                      <PaymentsOutlinedIcon
                        fontSize="small"
                        className="mr-1 fs-icon"
                      />
                      Cashout
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/spin-a-wheel"
                      className="dropdown-item"
                      onClick={handleLinkClick}
                    >
                      <FilterTiltShift
                        fontSize="small"
                        className="mr-1 fs-icon"
                      />
                      Spin a Wheel
                    </Link>
                  </li>
                  <li>
                    <Link onClick={handleLogout} className="dropdown-item">
                      <LogoutIcon fontSize="small" className="mr-1 fs-icon" />
                      Logout
                    </Link>
                  </li>
                </ul>
              </>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Topheader;
